import React, { memo } from 'react'
import { useStateValue } from 'context/store'
import { Route, useHistory } from 'react-router-dom'
import NoMatchApplication from 'components/Routes/noMatchPage/NoMatchApplication'
import { LOCALSTORAGE_KEYS } from 'utils/constants'


function SecureRoute({ component: Component, location, ...rest }) {
   const [{ sessionUser }] = useStateValue()
   const [{ authorizedMenuUrlList }] = useStateValue()
   const history = useHistory()

   const logoutAndCleanStore = () => {
      for (const [, values] of Object.entries(LOCALSTORAGE_KEYS)) {
         localStorage.removeItem(values)
      }
      history.push('/auth/login', { replace: true })
   }

   return (
      <Route
         {...rest}
         render={props => {
            if (authorizedMenuUrlList && authorizedMenuUrlList.data.length) {
               if (authorizedMenuUrlList.data.indexOf(location.pathname) < 0) {
                  return <NoMatchApplication />
               }
            }

            return sessionUser?.authenticated ? (
               <Component {...props} {...rest} />
            ) : (
               logoutAndCleanStore()
            )
         }}
      />
   )
}

export default memo(SecureRoute)
